// Common return shape for every per-table sync pass. `pushed` and `pulled`
// count rows successfully written in either direction; `conflicts` counts
// incoming rows that were dropped because the local copy was newer
// (last-write-wins by `updatedAt`). `errors` is intentionally string-valued
// so the UI can render it without leaking PII or stack traces.
export interface SyncResult {
  pushed: number;
  pulled: number;
  conflicts: number;
  errors: string[];
}

export const EMPTY_SYNC_RESULT: SyncResult = {
  pushed: 0,
  pulled: 0,
  conflicts: 0,
  errors: [],
};

export type SyncTableName = 'check_ins' | 'tenth_steps' | 'sponsor_tasks';

// Returned from the orchestrator. Per-table results are folded into the top
// totals so the badge can show a single "12 synced" number while the test
// suite can still inspect what happened per table.
export interface SyncAllResult extends SyncResult {
  byTable: Record<SyncTableName, SyncResult>;
}
